import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ea8d7c72&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ea8d7c72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8d7c72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea8d7c72')) {
      api.createRecord('ea8d7c72', component.options)
    } else {
      api.reload('ea8d7c72', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ea8d7c72&scoped=true&", function () {
      api.rerender('ea8d7c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/court/inlineCourt/index.vue"
export default component.exports